/* eslint-disable @typescript-eslint/no-explicit-any */

import { Flex } from '@chakra-ui/react'
import dynamic from 'next/dynamic'

import LazyLoad from '@/lib/LazyLoad'

import LinkSection from '@/features/Services/templates/LinkSection'
import { Header, Footer } from '@/components/Landing'

const DynamicBlog = dynamic<unknown>(
  () => {
    return import('@/components/Landing').then((mod) => mod.Blog)
  },
  { ssr: false },
)

const DynamicContact = dynamic<unknown>(
  () => {
    return import('@/components/Landing').then((mod) => mod.Contact)
  },
  { ssr: false },
)

export default function withServiceLayout(
  PageComponent: React.FC<any>,
): React.FC<any> {
  function EnhancedPageComponent(props: any) {
    return (
      <Flex
        sx={{
          overflow: 'hidden',
          flexDirection: 'column',
          w: 'full',
          alignItems: 'stretch',
        }}
      >
        <Header isAltStyle />
        <PageComponent {...props} />
        <LinkSection />
        <LazyLoad>
          <DynamicBlog />
        </LazyLoad>
        <LazyLoad>
          <DynamicContact />
        </LazyLoad>
        <Footer />
      </Flex>
    )
  }

  return EnhancedPageComponent
}
